export function truncate(str: string, length: number) {
  if (str.length <= length) return str;

  const ellipsis = '...';

  return str.split(' ').reduce((result, word) => {
    if (!result) {
      return word;
    }
    if (result.endsWith(ellipsis)) {
      return result;
    }
    if (result.length + word.length + ellipsis.length >= length) {
      return result + ellipsis;
    }
    return result + ' ' + word;
  }, '');
}
